import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.industries__splide' ).length ) {
        const industriesSplide = new Splide( '.industries__splide', {
          type: 'loop',
          perMove: 1,
          pagination: false,
          arrows: true,
          speed: 800,
          gap: '40px',
          autoWidth: true,
          focus: 'center',
          breakpoints: {
            768: {
              gap: '16px',
            },
          },
        } );

        industriesSplide.mount();
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'industries', COMPONENT );
} )( app );
